// extracted by mini-css-extract-plugin
export var fadeInOut = "_3j-3";
export var icon = "_3j-4";
export var savedIndicator = "_3j-2";
export var savingIndicator = "_3j-0";
export var spin = "_3j-1";